export enum TimerAction {
    None,
    EnableNavigation,
    AutoAdvance,
    DisplayMessage,
    TerminateSurvey,
}
